import { forEach } from 'lodash';
import isEmpty from 'lodash/isEmpty';

export const getParentDomain = () => {
    const host = window.location.host;
    const arr = host.split('.');
    if (arr.length > 1) {
        return arr[arr.length - 2] + '.' + arr[arr.length - 1];
    }
    return arr[0];
};

export function capitalizeFirstLetter(string) {
    if (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
}

export function accountType(checkText = '') {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (!isEmpty(userData)) {
        const { account_type } = userData;
        const roles = {
            admin: 'Admin',
            masterwhitelabel: 'Master',
            whitelabel: 'Whitelabel',
            commercial: 'Commercial',
            company: 'Company',
        };

        if (checkText) {
            const checkTextLowercase = checkText.toLocaleLowerCase();
            return account_type.includes(checkTextLowercase);
        }

        let accountTypeFormat;
        forEach(Object.entries(roles), ([key, value]) => {
            if (account_type.includes(key)) {
                accountTypeFormat = value;
                return false;
            }
        });

        return accountTypeFormat;
    }

    return false;
}

export function isMainAccount() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!isEmpty(user)) {
        const { account_type } = user;
        if (account_type) {
            if (account_type.includes('sub')) {
                return false;
            }
            return true;
        }
    }
}

export function escape(str) {
    const stringify = JSON.stringify(str);
    return stringify.replace(/\\n/g, '\\n')
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, '\\&')
        .replace(/\\r/g, '\\r')
        .replace(/\\t/g, '\\t')
        .replace(/\\b/g, '\\b')
        .replace(/\\f/g, '\\f').substring(1, stringify.length - 1);
}

export const copyToClipboard = value => {
    const $textarea = document.createElement('textarea');
    $textarea.value = value;
    document.body.appendChild($textarea);
    $textarea.select();
    document.execCommand('copy');
    document.body.removeChild($textarea);
};

export const renderStatusBadgeClassName = (status, transfer_status) => {
    if (transfer_status === 'manual_transferred' || transfer_status === 'auto_transferred') {
        return 'transferred';
    }
    switch (status) {
        case 'lost':
            return 'dark';
        case 'cancelled':
            return 'warning';
        case 'running':
            return 'info';
        default:
            return 'success';
    }
};

export const reorderDnD = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export const mapPortfolioSBOGame = (game_provider) => {
    if (game_provider === 'SBOLiveCasino' || game_provider === 'SBOLiveCasinoBeauty' || game_provider === 'sbolivecasino' || game_provider === 'sbolivecasinobeauty') {
        return 'casino';
    }
    if (game_provider === 'SBOGames' || game_provider === 'sbogames') {
        return 'games';
    }

    if (game_provider === 'VirtualSports' || game_provider === 'virtualsports') {
        return 'VirtualSports';
    }

    if (game_provider === 'SBOSportsBook' || game_provider === 'SBOSportsP2P' || game_provider === 'sbosportsbook' || game_provider === 'sbosportsp2p') {
        return 'SportsBook';
    }

    return 'SeamlessGameProviderApi';
};

const valibTime = (valueTime) => {
    let arryString = valueTime.split('');
    let valueValib = true;
    if (valueTime) {
        arryString.forEach((ch, index) => {
            if (index === 0) {
                if (+ch > 2) {
                    valueValib = false;
                }
            } else if (index === 1) {
                if (+arryString[0] === 2) {
                    if (+ch > 3) {
                        valueValib = false;
                    }
                }
            } else if (index === 2) {
                if (+ch > 5) {
                    valueValib = false;
                }
            }
        });
        return valueValib;
    } else {
        return false;
    }
};

export const isAllowedHourTime = (formNumber) => {
    const { value } = formNumber;

    if (value === '') {
        return true;
    }

    return valibTime(value);
};

export const DayOfWeeks = [
    {
        value: 1,
        day: 'Monday',
        isChecked: false
    },
    {
        value: 2,
        day: 'Tuesday',
        isChecked: false
    },
    {
        value: 3,
        day: 'Wednesday',
        isChecked: false
    },
    {
        value: 4,
        day: 'Thursday',
        isChecked: false
    },
    {
        value: 5,
        day: 'Friday',
        isChecked: false
    },
    {
        value: 6,
        day: 'Saturday',
        isChecked: false
    },
    {
        value: 0,
        day: 'Sunday',
        isChecked: false
    },
];

export const StringCurrencyDefault = (isRp) => {
    if (isRp) {
        if (window.appName === 'thl') {
            return '฿';
        }
        return 'Rp';
    } else {
        if (window.appName === 'thl') {
            return 'THB';
        }
    }
    return 'IDR';
};

export const StringTimeMaket = () => {
    if (window.appName === 'thl') {
        return '(UTC+07)';
    }
    return '(UTC+07)';
};

export const StringTimeCleaningUpByMaket = () => {
    if (window.appName === 'thl') {
        return '~ 8:30AM UTC+7';
    }
    return '~ 8:30AM UTC+7';
};

export const DailyReportProviderName = (pathname)=> {
    if (pathname !== '') {
        const pNameLowerCase = pathname.toLowerCase();
        const pNames = pNameLowerCase.split('/');
        const providerName = pNames[pNames.length - 1];
        let prd = providerName;
        switch (providerName) {
            case 'pragmaticplaylive':
                prd = 'pragmaticplayLive';
                break;
            case 'sexybaccarat':
                prd = 'SexyBaccarat';
                break;
            case 'sbogames':
                prd = 'SBOGames';
                break;
            case 'virtualsports':
                prd = 'VirtualSports';
                break;
            case 'sbolivecasino':
                prd = 'SBOLiveCasino';
                break;
            case 'sbolivecasinobeauty':
                prd = 'SBOLiveCasinoBeauty';
                break;
            case 'sbosportsbook':
                prd = 'SBOSportsBook';
                break;
            case 'sbosportsp2p':
                prd = 'SBOSportsP2P';
                break;
            default:
                break;
        }

        return prd;
    }
};

export const GetEventNameByType = (event_type)=> {
    if (event_type === 'bonus_new_member') {
        return 'Bonus New Member';
    }
    if (event_type === 'bonus_deposit') {
        return 'Bonus Deposit';
    }

    if (event_type === 'bonus_cashback') {
        return 'Bonus Cashback';
    }

    if (event_type === 'bonus_turnover') {
        return 'Bonus Turnover';
    }

    if (event_type === 'bonus_cashback') {
        return 'Bonus Cashback';
    }

    if (event_type === 'manual_freebet') {
        return 'Manual Freebet';
    }

    if (event_type === 'upload_bonus') {
        return 'Upload Bonus';
    }

    if (event_type === 'lucky_spin_for_newcomer') {
        return 'Lucky Spin For Newcomer';
    }

    if (event_type === 'daily_spin_bonus') {
        return 'Daily Spin Bonus';
    }

    if (event_type === 'bonus_smartico') {
        return 'Smartico Bonus';
    }

    return '';
};

export function truncateDecimal(value, precision) {
    let step = Math.pow(10, precision || 0);
    let temp = Math.trunc(step * value);

    return temp / step;
}

export const processAmount = (amount) => {
    if (amount === null) {
        return null;
    }
    return parseFloat(String(amount).replace(/,/g, ''));
};
